import React, { useState } from "react";
import { Button, Card, Form, Input, message} from "antd";
import HeaderComponent from "../component/header";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { LoginRequest } from "../constant";
import { api_login } from "../api/verify";
import { useNavigate } from "react-router-dom";

const LoginPage: React.FC = () => {
    const navigate = useNavigate();

    const onFinish = (logindata: LoginRequest) => {
        api_login(logindata.username, logindata.password)
        .then((res) => {
            if ("access_token" in res) {
                message.success('Success to login!')
                navigate("/dashboard");
            } else {
                message.error(res.errorMsg);
                return
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        });
    };

    return (
        <div>
            <HeaderComponent />
            <div className="flex justify-center items-center body-height text-style">
                <Card className="w-80 shadow-lg">
                    <h2 className="text-2xl font-bold text-center mb-4 text-style">Login</h2>
                    <Form
                    name="login"
                    onFinish={onFinish}
                    layout="vertical"
                    initialValues={{ remember: true }}
                    >
                    <Form.Item
                        className='custom-font'
                        name="username"
                        label="Username"
                        rules={[
                        { required: true, message: "Please input your ID!" },
                        ]}
                    >
                        <Input prefix={<UserOutlined />} />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[
                        { required: true, message: "Please input your password!" },
                        { min: 6, message: "The length of password must be at least 6 characters." },
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="••••••" />
                    </Form.Item>

                    <Form.Item className='flex justify-center'>
                        <Button type="primary" htmlType="submit" className="w-32 text-style">
                        Login
                        </Button>
                    </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default LoginPage;